// extracted by mini-css-extract-plugin
export var leftArrowIcon = "ContentSlider-module--leftArrowIcon--499f3";
export var rightArrowIcon = "ContentSlider-module--rightArrowIcon--6a8f2";
export var wrapper = "ContentSlider-module--wrapper--0d766";